import { render, staticRenderFns } from "./MatchEmpty.vue?vue&type=template&id=04e82706&scoped=true"
import script from "./MatchEmpty.vue?vue&type=script&lang=js"
export * from "./MatchEmpty.vue?vue&type=script&lang=js"
import style0 from "./MatchEmpty.vue?vue&type=style&index=0&id=04e82706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e82706",
  null
  
)

export default component.exports